import { Component } from '@angular/core';

import { LayoutConfig } from '../../config/layout.config';
import { MenuItem } from '../../shared/models/menu-item.model';

@Component({
	selector: 'app-dashboard-layout',
	templateUrl: './dashboard-layout.component.html',
	styleUrls: ['./dashboard-layout.component.scss']
})
export class DashboardLayoutComponent {

	sidebarConfig: any;
	menuItems: Array<MenuItem>;

	constructor() {
		this.sidebarConfig = LayoutConfig.sidebarCompressedConfig;

		this.menuItems = [
			{
				'title': 'Home',
				'icon': 'fa fa-home',
				// 'icon': '../../assets/images/home.png',
				'show': false,
				'path': '',
				'children': []
			},
			{
				'title': 'Trip',
				'icon': 'fa fa-truck',
				// 'icon': '../../assets/images/trip.png',
				'show': false,
				'path': '/trip/trip-listing',
				'children': [
					// {
					// 	'title': 'Trip History',
					// 	'icon': 'icon-note',
					// 	'path': '/trip/trip-listing'
					// },
					// {
					// 	'title': 'Add Trip',
					// 	'icon': 'icon-note',
					// 	'path': '/trip/add-trip'
					// }
				]
			},
			{
				'title': 'Reports',
				// 'icon': '../../assets/images/report.png',
				'icon': 'fa fa-file',
				'show': false,
				'path': '/report',
				'children': []
			},
			{
				'title': 'Settings',
				'icon': 'fa fa-cog',
				// 'icon': '../../assets/images/settings.png',
				'show': false,
				'disabled': false,
				'children': [
					{
						'title': 'Basic Info',
						'icon': 'icon-note',
						'path': '/settings/basic-info'
					},
					{
						'title': 'Manage Users',
						'icon': 'icon-note',
						'path': '/settings/manage-users'
					},
					{
						'title': 'Manage Rates',
						'icon': 'icon-note',
						'path': '/settings/manage-rates'
					},
					{
						'title': 'Geo Fence',
						'icon': 'icon-note',
						'path': 'settings/geofencing'
					},
					{
						'title': 'Manage Locations',
						'icon': 'icon-note',
						'path': 'settings/manage-locations'
					}
				]
			}
		];
	}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/layout/dashboard-layout/dashboard-layout.component.ts